(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-shipping-info"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    function addBusinessDays(date, days, skipWeekends) {
      var result = new Date(date.getTime());
      var remaining = days;
      var guard = 0;
      while (remaining > 0 && guard < 200) {
        result.setDate(result.getDate() + 1);
        guard++;
        if (skipWeekends) {
          var weekday = result.getDay();
          if (weekday === 0 || weekday === 6) continue;
        }
        remaining--;
      }
      return result;
    }

    function formatDate(date) {
      return new Intl.DateTimeFormat('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric'
      }).format(date);
    }

    function refreshShippingEstimates() {
      var cards = document.querySelectorAll('[data-shipping-estimate]');
      cards.forEach(function (card) {
        var target = card.querySelector('[data-shipping-dates]');
        if (!target) return;

        var processingMin = parseInt(card.dataset.processingMin, 10) || 0;
        var processingMax = parseInt(card.dataset.processingMax, 10) || 0;
        var transitMin = parseInt(card.dataset.transitMin, 10) || 0;
        var transitMax = parseInt(card.dataset.transitMax, 10) || 0;
        var skipWeekends = card.dataset.skipWeekends === 'true';

        var today = new Date();
        var start = addBusinessDays(today, processingMin + transitMin, skipWeekends);
        var end = addBusinessDays(today, processingMax + transitMax, skipWeekends);

        var startText = formatDate(start);
        var endText = formatDate(end);
        target.textContent = startText === endText ? startText : startText + ' – ' + endText;
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', refreshShippingEstimates);
    } else {
      refreshShippingEstimates();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-purchase-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    function init() {
      var bar = document.querySelector('[data-sticky-buy]');
      var mainCta = document.querySelector('[data-main-add-to-cart]');
      if (!bar || !mainCta) return;

      var priceEl = bar.querySelector('[data-sticky-buy-price]');
      var ctaBtn = bar.querySelector('[data-sticky-buy-cta]');
      var addLabel = bar.dataset.labelAdd;
      var soldOutLabel = bar.dataset.labelSoldOut;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      });
      observer.observe(mainCta);

      var syncingDisabled = new MutationObserver(function () {
        ctaBtn.disabled = mainCta.disabled;
      });
      syncingDisabled.observe(mainCta, { attributes: true, attributeFilter: ['disabled'] });

      document.addEventListener('change', function (e) {
        if (!e.target.matches('[data-variant-picker] input[type="radio"]')) return;
        var price = parseInt(e.target.dataset.price, 10);
        if (priceEl && e.target.dataset.price && window.formatMoney) priceEl.textContent = window.formatMoney(price);

        var available = e.target.dataset.available !== 'false';
        ctaBtn.disabled = !available;
        ctaBtn.textContent = available ? addLabel : soldOutLabel;
      });

      ctaBtn.addEventListener('click', function () {
        if (ctaBtn.disabled || !mainCta.form) return;
        mainCta.form.requestSubmit(mainCta);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
